// removed by extract-text-webpack-plugin
module.exports = {"ant-checkbox-group-item":"ant-checkbox-group-item","border-left-primary":"border-left-primary"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/pgs/CnvReadDetail/CnvRead.scss
// module id = 1402
// module chunks = 0